import React, { type ReactNode } from 'react';
import { IconButton, IconName, Modal } from '@secretescapes/falcon';
import { Container, Header } from './Overlay.styles';

export interface OverlayProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
}

export const Overlay = ({ isOpen, onClose, children }: OverlayProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} withCloseButton={false}>
      <Container>
        <Header>
          <IconButton
            dataAttributes={{ testid: 'close-icon' }}
            icon={IconName.close}
            onClick={onClose}
            hasShadow={false}
          />
        </Header>
        {children}
      </Container>
    </Modal>
  );
};
